import Image from 'next/image';
import type React from 'react';

import { Popup } from '~components/Popup';
import type { PopupActions } from '~components/Popup/types';
import { useTranslations } from '~i18n/hooks';
import type { Ref } from '~types/Ref';

import Close from '../../../../../public/assets/icons/close.svg';
import { ReportButtonWrapper, ReportTextWrapper } from '../styles';
import { CloseButtonWrapper, contentStyle } from './styles';

interface Props {
	trigger: React.ReactElement;
	openReport: () => void;
	closePopup: () => void;
	onClose: () => void;
}
export const ReportMessage = ({
	trigger,
	openReport,
	closePopup,
	onClose,
	ref,
}: Props & Ref<PopupActions>) => {
	const t = useTranslations('Report');

	return (
		<Popup
			ref={ref}
			trigger={trigger}
			disabled
			position="bottom right"
			contentStyle={{ marginLeft: -35, marginTop: -10 }}
			overlayStyle={{ backgroundColor: 'black', opacity: 0.4 }}
			arrowStyle={{ visibility: 'hidden' }}
			closeOnDocumentClick
			onClose={onClose}
		>
			<div className={contentStyle}>
				<ReportButtonWrapper onClick={openReport}>
					<Image
						src="/img/reports/message_report.png"
						alt="flag icon"
						width={15}
						height={15}
					/>
					<ReportTextWrapper data-name="report-button">
						{t('reportButtonTitle')}
					</ReportTextWrapper>
				</ReportButtonWrapper>
				<CloseButtonWrapper>
					<Close onClick={closePopup} />
				</CloseButtonWrapper>
			</div>
		</Popup>
	);
};
